var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"heatmap-container"},[_c('v-chart',{staticClass:"heatmap-chart",attrs:{"option":_vm.chartOptions,"lazy-update":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }